import {
  IQ_SEVERITY_LEVELS,
  type IqSeverityLevel,
} from 'src/app/shared/constants/iq-observation-action-labels';

/** @see IQ_SEVERITY_LEVELS */
export const SeverityLevels = IQ_SEVERITY_LEVELS;

export type SeverityLevel = IqSeverityLevel;

// Shared IQ observation shapes — single source of truth (do not duplicate).
export type {
  DeviceEvent,
  AccountDeviceData,
} from 'src/app/shared/types/iq-observation.model';

export interface LeadDetails {
  metric_date: string;
  time_window: string;
  lead_count: number;
  summary: string;
  action_label: SeverityLevel;
}

export interface QOELeadNetworkMetrics {
  device_name: string;
  details: LeadDetails[];
  expanded?: boolean;
}

export interface MetadataEntry {
  property: string;
  value: string | number | boolean; // Adjust based on actual data types
}

export type Metrics = { [key: string]: string | number | boolean }; // Adjust based on actual data types

export interface QualityOfExperience {
  time_frame: string | number | Date;
  edgeName: string;
  source: string;
  timestamp: string;
  carrier: string;
  region: string;
  score: number;
  qos: number;
  value: string;
  qos_category: string;
  datausage: number;
  anomalies: string;
  metadata: MetadataEntry[];
  device: string;
}

export interface LeadSummary {
  date: string;
  begin_time: string;
  end_time: string;
  device_lead_summaries: DeviceLeadSummary[];
}

export interface DeviceLeadSummary {
  device_name: string;
  lead_count: number;
  summary: string;
  action_label: SeverityLevel;
}
